<template>
  <div class="fetured-nfts">
    <h2 class="fetured-title title-black-1927B-30">{{ $t('collection-fetured') }}</h2>
    <Row type="flex" class="collection-outer" :gutter="22">
      <Col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" v-for="(item, index) in list" :key="index" class="img-wrap">
        <div class="top-img">
          <picture>
            <source type="image/avif" v-real-img-avif="{imgUrl: item.nftItemInfo[0].imgUrl}" />
            <img v-real-img="{imgUrl: item.nftItemInfo[0].imgUrl}" class="img-0" alt="nftImg" loading="lazy"/>
          </picture>
          <!-- v-real-img="{imgUrl: item.nftItemInfo[0].imgUrl, isLoading: item.isLoading}" @load="loadImage(item, 'list')" -->
          <div class="small-img-box">
            <div v-for="(imgItem, imgIndex) in smallImgList[index].nftItemInfo" :key="imgIndex">
              <picture>
                <source type="image/avif" v-real-img-avif="{imgUrl: imgItem.imgUrl}" />
                <img v-real-img="{imgUrl: imgItem.imgUrl}" alt="smallImg" :class="`img-${imgIndex + 1}`" loading="lazy"/>
              </picture>
            </div>
          </div>
        </div>
        <div class="bottom-info">
          <span class="title-black-PR-20 font-weight-500">{{ item.collectionName }}</span>
          <div class="creator-box-outer">
            <div class="creator-wrap">
              <picture>
                <source type="image/avif" v-real-img-avif="{imgUrl: item.creatorAvatarUrl}" />
                <img v-real-img="{imgUrl: item.creatorAvatarUrl}" alt="creatorImg" loading="lazy"/>
              </picture>
              <span class="title-black-PR-12 font-weight-300">by {{ item.creator }}</span>
            </div>
            <div class="total">
              <p class="title-white-PR-10 font-weight-100">{{ `Total ${item.itemCount} Items` }}</p>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
import { feturedNftsAPI } from '@/util/shareAPI.js'

export default {
  mounted () {
    this.getData()
  },
  mixins: [feturedNftsAPI],
  computed: {},
  data () {
    return {
      list: [],
      smallImgList: []
    }
  },
  methods: {
    //! -------------------------get區開始
    async getData () {
      try {
        // const { data } = await this.$api.get('gateway/app/index/collection/fetured/nfts')
        const data = await this.feturedNftsAPI()
        data.forEach(item => {
          item.isLoading = false
          item.isAll = false
        })
        this.list = [...data]
        this.smallImgHandler(data)
      } catch (err) {
        // this.$Message.error(this.$t(err.data.code))
      }
    },
    //! -------------------------get區結束
    //! -------------------------handler區開始
    smallImgHandler (data) {
      this.smallImgList = JSON.parse(JSON.stringify(data))
      this.smallImgList.forEach(item => {
        item.nftItemInfo.splice(0, 1)
      })
    },
    loadImage (item, arrayName) {
      item.isLoading = true
      if (this[arrayName].every(element => element.isLoading && !element.isAll)) {
        item.isAll = true
        const list = [...this[arrayName]]
        this[arrayName] = [...list]
      }
    }
    //! -------------------------handler區結束
    //! -------------------------modal區開始
    //! -------------------------modal區結束
    //! -------------------------post區開始
    //! -------------------------post區結束
  }
}
</script>
<style lang="scss">
.fetured-nfts {
  background-image: linear-gradient(90deg, rgba(153,188,237,0.2), rgba(153,248,207,0.3), rgba(255,214,199,0.3));
  padding: 4% 7% 7%;
  .fetured-title {
    text-align: center;
  }
  .collection-outer {
    margin-top: 40px;
    img {
      display: block;
    }
    .img-wrap {
      display: flex;
      flex-direction: column;
      margin-bottom: 40px;
    }
    .img-0 {
      width: 63vw;
      height: 63vw;
      border-radius: 10px;
      margin-right: 10px;
    }
    .img-1,
    .img-2,
    .img-3 {
      width: 19vw;
      height: 19vw;
      border-radius: 10px;
    }
    .small-img-box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 5px;
    }
    .top-img {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }
    .bottom-info {
      width: 100%;
    }
    .creator-box-outer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .creator-wrap {
      display: flex;
      align-items: center;
      img {
        display: block;
        width: 26px;
        height: 100%;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
    .total {
      padding: 0 10px;
      height: 25px;
      line-height: 25px;
      border-radius: 20px;
      text-align: center;
      background-image: linear-gradient(90deg, rgba(153, 188, 237, 1), rgba(153, 248, 207, 1), rgba(255, 214, 199, 1));
    }
  }
}
// *--------------------------PC版 開始--------------------------
@media screen and (min-width: 768px) {
  .fetured-nfts {
    .fetured-title {
      text-align: left;
    }
    .collection-outer {
      .img-wrap {
        margin-bottom: 0px;
      }
      .img-0 {
        width: 20vw;
        height: 20.2vw;
        margin-right: 0px;
      }
      .img-1,
      .img-2,
      .img-3 {
        width: 7vw;
        height: 6.5vw;
      }
      .top-img {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
